export enum AuthorityClientArea {
  CLIENT_AREA = '10.0',
}
